import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { nav, marca, whatsappLink } from "@/content";

export const Logo = ({ imgClass = "h-8 w-auto sm:h-9" }) => (
  <a href="#topo" data-testid="header-logo" className="flex items-baseline gap-2">
    {marca.logoUrl ? (
      <span className="flex items-center gap-3">
        <img src={marca.logoUrl} alt={`${marca.nome} ${marca.complemento}`} data-testid="logo-image"
          className={`${imgClass} drop-shadow-[0_0_14px_rgba(103,232,249,0.25)]`} />
        <span className="inline-block border-l border-white/15 pl-3 text-[10px] uppercase leading-tight tracking-[0.2em] text-brand-gradient sm:text-[11px] md:hidden lg:inline-block">
          Finanças<br />Inteligentes
        </span>
      </span>
    ) : (<>
    <span className="font-display text-2xl font-bold tracking-tight text-white">
      i<span className="text-cyan-300">CON</span>
    </span>
    <span className="hidden text-[11px] uppercase tracking-[0.2em] text-slate-400 lg:inline">
      {marca.complemento}
    </span>
    </>)}
  </a>
);

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled || open ? "border-b border-white/10 bg-[#050b1a]/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-6 md:flex lg:gap-10">
          {nav.links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-slate-300 transition-colors duration-200 hover:text-cyan-300">
              {l.label}
            </a>
          ))}
        </nav>
        <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="header-cta-btn"
          className="btn-ghost hidden whitespace-nowrap md:inline-flex">
          {nav.cta}
        </a>
        <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setOpen(!open)}
          className="text-white md:hidden">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-white/10 px-6 pb-8 pt-4 md:hidden">
          {nav.links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.href.slice(1)}`}
              className="block py-3 text-lg text-slate-200">
              {l.label}
            </a>
          ))}
          <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="mobile-cta-btn"
            className="btn-primary mt-4 w-full justify-center">
            {nav.cta}
          </a>
        </div>
      )}
    </header>
  );
};
